// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import ElementUI, { Message } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import store from './store';
import VueCookie from 'vue-cookie';
import axios from './assets/js/axios';
import './filters'

import '../src/assets/css/style.css';
// 一次引入全部图标
import 'vue-awesome/icons';
import Icon from 'vue-awesome/components/Icon';
import moment from 'moment';
import router from './router';
import crypto from 'crypto-js';
import echarts from 'echarts';
import Viewer from 'v-viewer';
import 'viewerjs/dist/viewer.css';
import Utils from './assets/js/utils';
// 图片浏览组件
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import jquery from 'jquery';
Vue.use(ElementUI)
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999
  }
});
Vue.prototype.$echarts = echarts;
Vue.prototype.$moment = moment;
Vue.prototype.Utils = Utils;
Vue.prototype.$ = jquery;
// 全局注册icon
Vue.component('icon', Icon);
Vue.use(VueCookie);
Vue.use(router);
Vue.use(preview);
// 开发环境需先过登陆，然后复制一个token过来
if (process.env.NODE_ENV === 'development') {
  const token = "56837d2926d94e37b0f9759d1523d03b";
  VueCookie.set('token', token);
}
// 直接替换token 或者在浏览器控制台调用setCookie即可
window.setCookie = t => {
  document.cookie = `token=${t};domain=hzfapi.com;`
};

// 给元素内的输入框绑定键盘回车事件
Vue.directive('keyup-enter', {
  inserted(el, binding) {
    let $inputs = el.getElementsByTagName('input');
    Array.from($inputs).forEach($item => {
      $item.addEventListener('keydown', event => {
        let e = event || window.event;
        // 按下enter键事件
        if (e.keyCode === 13) {
          if (binding.value) {
            setTimeout(() => {
              binding.value();
            }, 100);
          }
        }
      });
    });
  }
});

router.beforeEach((to, from, next) => {
  // 本质这边也要判断有无登录防止闪烁 接口也需要拦截登录状态
  let token = Vue.cookie.get('token');
  if (to.path == '/home') {
    store.commit('setChooseMenu', '');
  } else {
    store.commit('setChooseMenu', to.path);
  }
  if (token) {
    next();
  } else {
    if (
      to.path !== '/error' &&
      to.path !== '/unauthorized' &&
      to.path !== '/login'
    ) {
      let host = window.location.host + '/saasossplatform';
      let protocol = location.protocol
      window.location.href = `http://sso.huifenqi.com/sso/oauth/logout/?next=${protocol}//${host}/index/`;
      next('/login');
    } else {
      next();
    }
  }
});

/**
 * 分转元，string对象扩展，暂不支持负数
 * @param  {[type]} !String.prototype.toYuan [description]
 * @return {[type]}                          [description]
 */
if (!String.prototype.toYuan) {
  String.prototype.toYuan = function () {
    let num = this;
    if (!num.length) {
      return 0;
    }
    if (isNaN(num)) {
      return num;
    } else {
      let r = num < 0 ? -1 : 1;
      num *= r;
      return (
        r *
        (num < 1
          ? num
          : `${Math.floor(num / 100)}.${
          num % 100 < 10 ? '0' + (num % 100) : num % 100
          }`)
      );
    }
  };
}

Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

Vue.prototype.$sha256 = crypto.SHA256;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App, Icon },
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js